import Loader from "@assets/cryptoloader.json";
import { Player } from "@lottiefiles/react-lottie-player";
interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children?: any;
  loading?: boolean;
}

const Screen = ({ children, loading }: Props) => {
  if (loading)
    return (
      <div className="max-w-screen-xl mx-auto h-[80vh] flex items-center justify-center ">
        {/* <Lottie style={{ height: 300, width: 300 }} animationData={Loader} /> */}
        <Player
          loop
          src={Loader}
          autoplay
          speed={4}
          style={{ height: 300, width: 300 }}
        />
      </div>
    );

  return (
    <div className="max-w-screen-xl mx-auto p-2 md:py-5 md:px-4">
      {children}
    </div>
  );
};

export default Screen;
